module.exports = {
    language: {
        name: 'cn'
    },
    managerPage:{
    	txt1:'个人资料',
    	txt2:'修改密码',
        txt3:'安全退出',
        txt4:'返回工作台',
        txt5:'我的桌面',
        txt6:'终端',
        txt7:'系统设置',
        txt8:'确定',
        txt9:'取消',
        txt10:'退出成功!',
        txt11:'确定要退出？',
        txt12:'安全退出',
    },
    login:{
        txt1:'请输入用户名',
        txt2:'请输入密码',
        txt3:'登录'
    },
    modal:{
        txt1:'分配用户',
        txt2:'序号',
        txt3:'用户名',
        txt4:'真实姓名',
        txt5:'手机号',
        txt6:'单位名称',
        txt7:'角色',
        txt8:'请至少选择一个用户'
    },
    uDialog:{
        txt1:'确 定',
        txt2:'取 消'
    },
    uploadDialog:{
        txt1:'正在上传'
    },
    applicationManagement:{
        txt1:'当前位置：',
        txt2:'应用管理',
        txt3:'全部应用',
        txt4:'请输入应用名称',
        txt5:'查询',
        txt6:'序号',
        txt7:'名称',
        txt8:'版本',
        txt9:'说明',
        txt10:'类型',
        txt11:'状态',
        txt12:'未安装',
        txt13:'已安装',
        txt14:'安装中',
        txt15:'操作',
        txt16:'卸载',
        txt17:'安装',
        txt18:'确定要删除该用户吗',
        txt19:'同时会删除该用户下的所有数据。',
        txt20:'删除',
        txt21:'取消',
        txt22:'确定',
        txt23:'已取消删除',
        txt24:'删除成功',
        txt25:'操作成功',
        txt26:'请选择'
    },
    contactPage:{
        txt1:'当前位置：',
        txt2:'版权管理',
        txt3:'联系我们',
        txt4:'版权信息',
        txt5:'请留下你的宝贵意见和想法',
        txt6:'取消',
        txt7:'提交',
        txt8:'当前版本',
        txt9:'当前状态：',
        txt10:'当前系统状态',
        txt11:'已激活',
        txt12:'未激活',
        txt13:'导出配置',
        txt14:'续期',
        txt15:'激活',
        txt16:'检查更新：',
        txt17:'系统检测新版本',
        txt18:'最新版本',
        txt19:'立即升级',
        txt20:'正在升级',
        txt21:'备份与恢复：',
        txt22:'导出数据',
        txt23:'导入数据',
        txt24:'底部版权：',
        txt25:'请输入内容',
        txt26:'登录页面Logo：',
        txt27:'提交',
        txt28:'操作成功!',
        txt29:'当前限制选择 1 个文件，本次选择了1个文件，共选择了1个文件，请删除后上传',
        txt30:'上传文件只能是JPG、JPEG、PNG格式!',
        txt31:'下载成功！',
        txt32:'导出成功！'
    },
    diskMain:{
        txt1:'序号',
        txt2:'文件名',
        txt3:'请输入内容',
        txt4:'文件大小',
        txt5:'上传时间',
        txt6:'全选',
        txt7:'暂无数据',
        txt8:'确定删除所选的文件吗',
        txt9:'删除文件后不可找回',
        txt10:'删除',
        txt11:'取消',
        txt12:'确定',
        txt13:'已取消删除',
        txt14:'删除成功！',
        txt15:'新建文件夹',
        txt16:'必须以字母开头，且以字母、数字、下划线(_)随意组合'
    },
    project:{
        txt1:'选择项目',
        txt2:'项目名',
        txt3:'项目描述',
        txt4:'创建时间',
        txt5:'请选择项目'
    },
    share:{
        txt1:'分享',
        txt2:'平台分享',
        txt3:'请输入您要搜索的用户',
        txt4:'用户名',
        txt5:'链接分享',
        txt6:'分享形式',
        txt7:'私密链接',
        txt8:'提取码',
        txt9:'仅限拥有提取码者可查看，更加隐私安全',
        txt10:'有效期',
        txt11:'私密链接',
        txt12:'请输入内容',
        txt13:'提取码',
        txt14:'请输入内容',
        txt15:'成功创建私密链接，请复制链接及提取码，将链接发送给你好友',
        txt16:'确 定',
        txt17:'复制链接及提取码',
        txt18:'创建链接',
        txt19:'关 闭',
        txt20:'7天',
        txt21:'15天',
        txt22:'30天',
        txt23:'永久',
        txt24:'复制成功！',
        txt25:'请选择过期时间!',
        txt26:'分享成功!',
        txt27:'请选择要分享的用户'
    },
    myDoc:{
        txt1:'上传文件',
        txt2:'上传文件夹',
        txt3:'新建文件夹',
        txt4:'删除',
        txt5:'重命名',
        txt6:'下载',
        txt7:'分享',
        txt8:'请选择',
        txt9:'请输入您要搜索的文件',
        txt10:'查询',
        txt11:'当前位置：',
        txt12:'我的数据',
        txt13:'我的文件',
        txt14:'备选项 ',
        txt15:'列表排列',
        txt16:'宫格排列',
        txt17:'请至少选择一个文件或者文件夹',
        txt18:'确定删除所选的文件吗',
        txt19:'删除文件后不可找回',
        txt20:'确定',
        txt21:'取消',
        txt22:'请选择一个文件或文件夹',
        txt23:'请输入名称',
        txt24:'重命名成功!',
        txt25:'删除成功!',
        txt26:'保存成功!',
        txt27:'文件夹',
        txt28:'新建文件夹',
        txt29:'请输入文件夹名称',
        txt30:'必须以字母开头，且以字母、数字、下划线(_)随意组合',
        txt31:'新建文件夹成功！',
        txt32:'下载成功！',
        txt33:'已关闭下载权限',
        txt34:'文件上传',
        txt35:'检测到上传的该文件已经存在，请确认后继续?',
        txt36:'忽略',
        txt37:'覆盖',
        txt38:'保留两者',
        txt39:'数据同步客户端下载',
        txt40:'客户端支持 Win.Mac 版本',
        txt41:'仅支持选择一个文件下载',
        txt42:'打开客户端'
    },
    myShare:{
        txt1:'当前位置：',
        txt2:'我的数据',
        txt3:'我的分享',
        txt4:'取消分享',
        txt5:'分享类型',
        txt6:'平台分享',
        txt7:'链接分享',
        txt8:'分享时间',
        txt9:'等文件',
        txt10:'请至少选择一个文件或者文件夹',
        txt11:'此操作将取消该文件的分享, 是否继续?',
        txt12:'取消分享',
        txt13:'确定',
        txt14:'取消',
        txt15:'取消分享成功！',
        txt16:'此操作将永久删除该现场见证记录, 是否继续?',
        txt17:'文件名',
        txt18:'接收者',
        txt19:'共享者',
    },
    patfromShare:{
        txt1:'当前位置：',
        txt2:'我的数据',
        txt3:'我的文件',
        txt4:'平台分享',
        txt5:'链接分享',
        txt6:'取消',
        txt7:'确定',
        txt8:'复制链接及提取码',
        txt9:'创建链接',
        txt10:'请输入您要搜索的用户',
        txt11:'用户名',
        txt12:'分享形式',
        txt13:'私密链接',
        txt14:'提取码',
        txt15:'仅限拥有提取码者可查看，更加隐私安全',
        txt16:'有效期',
        txt17:'请选择',
        txt18:'私密链接',
        txt19:'请输入内容',
        txt20:'提取码',
        txt21:'成功创建私密链接，请复制链接及提取码，将链接发送给你好友',
        txt22:'7天',
        txt23:'15天',
        txt24:'30天',
        txt25:'永久',
        txt26:'请选择要分享的用户',
        txt27:'复制成功！',
        txt28:'请选择过期时间',
        txt29:'分享成功!'
    },
    receiveShare:{
        txt1:'当前位置：',
        txt2:'我的数据',
        txt3:'接收分享',
        txt4:'保存至我的文件',
        txt5:'删除',
        txt6:'文件名',
        txt7:'分享类型',
        txt8:'平台分享',
        txt9:'链接分享',
        txt10:'分享时间',
        txt11:'接收成功',
        txt12:'操作成功！',
        txt13:'此操作将取消该文件的分享, 是否继续?',
        txt14:'确定',
        txt15:'取消',
        txt16:'取消分享成功！'
    },
    MyProjectManagementEdit:{
       txt1:'编辑项目',
       txt2:'创建项目',
       txt3:'请输入项目名称（字母、数字、下划线的组合）',
       txt4:'确 定',
       txt5:'取 消',
       txt6:'请输入项目名称',
       txt7:'必须以字母开头，且以字母、数字、下划线(_)随意组合',
       txt8:'不能是root'
    },
    MyProjectManagementList:{
        txt1:'管理员：',
        txt2:'参与者：',
        txt3:'您本人创建本项目的日期：'
    },
   aduit:{
        txt1:'当前位置：',
        txt2:'共享空间',
        txt3:'审批管理',
        txt4:'请选择',
        txt5:'请输入应用名称',
        txt6:'查询',
        txt7:'申请人',
        txt8:'申请文件',
        txt9:'事项',
        txt10:'申请下载',
        txt11:'申请时间',
        txt12:'状态',
        txt13:'等待审核',
        txt14:'已同意',
        txt15:'已拒绝',
        txt16:'操作',
        txt17:'同意',
        txt18:'拒绝',
        txt19:'下载',
        txt20:'全部',
        txt21:'我审批的',
        txt22:'我申请的',
        txt23:'操作成功！',
        txt24:'确定要删除该用户吗',
        txt25:'同时会删除该用户下的所有数据。',
        txt26:'删除',
        txt27:'取消',
        txt28:'确定',
        txt29:'已取消删除',
        txt30:'删除成功!',
        txt31:'确定要冻结该用户吗',
        txt32:'冻结后将无法登陆平台。',
        txt33:'冻结',
        txt34:'已取消冻结',
        txt35:'冻结成功!'
    },
    authoritySettings:{
        txt1:'当前位置：',
        txt2:'共享空间',
        txt3:'管理的项目',
        txt4:'权限设置',
        txt5:'返回上一页',
        txt6:'保存',
        txt7:'项目文件权限设置',
        txt8:'项目管理员',
        txt9:'读取',
        txt10:'写入',
        txt11:'浏览',
        txt12:'项目成员',
        txt13:'项目以外成员',
        txt14:'操作成功'
    },
    management:{
        txt1:'当前位置：',
        txt2:'共享空间',
        txt3:'管理的项目',
        txt4:'参与的项目',
        txt5:'请输入项目名称',
        txt6:'查询',
        txt7:'创建项目',
        txt8:'管理员：',
        txt9:'成员：',
        txt10:'参与者：',
        txt11:'本项目',
        txt12:'创建时间：',
        txt13:'暂无项目'
    },
    managementDetail:{
        txt1:'当前位置：',
        txt2:'共享空间',
        txt3:'管理的项目',
        txt4:'参与的项目',
        txt5:'上传',
        txt6:'文件',
        txt7:'文件夹',
        txt8:'导入',
        txt9:'申请下载',
        txt10:'下载',
        txt11:'项目成员',
        txt12:'项目设置',
        txt13:'返回上一页',
        txt14:'序号',
        txt15:'文件名',
        txt16:'请输入内容',
        txt17:'上传时间',
        txt18:'操作',
        txt19:'重命名',
        txt20:'申请下载',
        txt21:'下载',
        txt22:'删除',
        txt23:'上传我的数据',
        txt24:'当前位置：',
        txt25:'我的文件',
        txt26:'序号',
        txt27:'文件名',
        txt28:'请输入内容',
        txt29:'上传时间',
        txt30:'确 定',
        txt31:'取 消',
        txt32:'申请下载',
        txt33:'请注意，非项目管理员下载资料需要向管理员申请，可以“确认”后：',
        txt34:'1、自行通知管理员，管理员通过“我的项目->审批管理”进行确认你的申请；',
        txt35:'2、审批结果，可在“我的项目->审批管理”中进行查看',
        txt36:'申请成功!',
        txt37:'请输入名称',
        txt38:'确定',
        txt39:'取消',
        txt40:'重命名成功!',
        txt41:'请至少选择一个文件或者文件夹',
        txt42:'确定删除所选的文件吗',
        txt43:'删除文件后不可找回',
        txt44:'确定',
        txt45:'取消',
        txt46:'删除成功',
        txt47:'下载成功！',
        txt48:'已关闭下载权限',
        txt49:'添加标签成功！',
        txt50:'删除标签成功！',
        txt51:'删除用户成功！',
        txt52:'请至少选择一个文件或者文件夹',
        txt53:'上传我的数据成功！'
    },
    projectMembers:{
        txt1:'当前位置：',
        txt2:'共享空间',
        txt3:'管理的项目',
        txt4:'已加入的成员',
        txt5:'添加成员',
        txt6:'搜索',
        txt7:'查询',
        txt8:'返回上一页',
        txt9:'创建者',
        txt10:'管理者',
        txt11:'成员',
        txt12:'设置为管理员',
        txt13:'移出',
        txt14:'添加'
    },
    projectSettings:{
        txt1:'当前位置：',
        txt2:'共享空间',
        txt3:'管理的项目',
        txt4:'项目设置',
        txt5:'返回上一页',
        txt6:'项目设置',
        txt7:'保存',
        txt8:'删除项目',
        txt9:'项目名称',
        txt10:'请输入项目名称',
        txt11:'项目文件权限设置',
        txt12:'项目管理员',
        txt13:'读取',
        txt14:'写入',
        txt15:'浏览',
        txt16:'项目成员',
        txt17:'项目以外成员',
        txt18:'项目描述',
        txt19:'确认要把该项目彻底删除吗？',
        txt20:'删除的项目不可找回，请三思后删除。',
        txt21:'删除',
        txt22:'确定',
        txt23:'取消',
        txt24:'删除成功!',
        txt25:'操作成功',
        txt26:'请输入项目描述'
    },
    Chart:{
        txt1:'CPU使用率',
        txt2:'MEMORY使用率',
        txt3:'使用率(%)'
    },
    PlatformMonitoringList:{
        txt1:'当前位置：',
        txt2:'平台监控',
        txt3:'集群监控',
        txt4:'服务器：'
    },
    userAssignment:{
        txt1:'分享',
        txt2:'平台分享',
        txt3:'请输入您要搜索的用户',
        txt4:'用户名',
        txt5:'链接分享',
        txt6:'分享形式',
        txt7:'私密链接',
        txt8:'提取码',
        txt9:'仅限拥有提取码者可查看，更加隐私安全',
        txt10:'有效期',
        txt11:'请选择',
        txt12:'私密链接',
        txt13:'提取码',
        txt14:'请输入内容',
        txt15:'成功创建私密链接，请复制链接及提取码，将链接发送给你好友',
        txt16:'确 定',
        txt17:'取 消',
        txt18:'复制链接及提取码',
        txt19:'关 闭',
        txt20:'请选择要分享的用户',
        txt21:'分享成功!'
    },
    addQueue:{
        txt1:'添加队列',
        txt2:'取消',
        txt3:'确定',
        txt4:'队列名称:',
        txt5:'请输入队列名称',
        txt6:'项目:',
        txt7:'请选择',
        txt8:'用户:',
        txt9:'请选择',
        txt10:'当前位置：',
        txt11:'资源管理',
        txt12:'队列管理',
        txt13:'添加队列',
        txt14:'全选',
        txt15:'暂无数据',
        txt16:'内网地址：',
        txt17:'当前状态：',
        txt18:'在线',
        txt19:'离线',
        txt20:'CPU核数',
        txt21:'请输入队列名称',
        txt22:'必须以字母开头，且以字母、数字、下划线(_)随意组合'
    },
    calculateDot:{
        txt1:'当前位置：',
        txt2:'资源管理',
        txt3:'计算节点',
        txt4:'添加节点',
        txt5:'内网地址：',
        txt6:'当前状态：',
        txt7:'在线',
        txt8:'离线',
        txt9:'确定删除该节点吗？',
        txt10:'删除该节点，该节点上的在线用户桌面将会被关闭！',
        txt11:'删除',
        txt12:'确定',
        txt13:'取消',
        txt14:'已取消删除',
        txt15:'删除成功!'
    },
    desktopDot:{
        txt1:'当前位置：',
        txt2:'资源管理',
        txt3:'桌面节点',
        txt4:'添加节点',
        txt5:'内网地址',
        txt6:'外网地址',
        txt7:'目前状态',
        txt8:'在线人数',
        txt9:'端口',
        txt10:'描述',
        txt11:'在线',
        txt12:'离线',
        txt13:'确定删除该节点吗？',
        txt14:'删除该节点，该节点上的在线用户桌面将会被关闭！',
        txt15:'删除',
        txt16:'确定',
        txt17:'取消',
        txt18:'已取消删除',
        txt19:'删除成功!'
    },
    editCalculateDot:{
        txt1:'当前位置：',
        txt2:'资源管理',
        txt3:'计算节点',
        txt4:'编辑节点',
        txt5:'添加节点',
        txt6:'返回上一页',
        txt7:'编辑节点',
        txt8:'添加节点',
        txt9:'取消',
        txt10:'确定',
        txt11:'主机名称',
        txt12:'请输入主机名称',
        txt13:'内网地址',
        txt14:'请输入内网IP',
        txt15:'描述',
        txt16:'请输入描述',
        txt17:'请输入主机名称',
        txt18:'请输入内网地址',
        txt19:'请输入有效合格的IP地址'
    },
    editDesktopDot:{
        txt1:'当前位置：',
        txt2:'资源管理',
        txt3:'桌面节点',
        txt4:'编辑节点',
        txt5:'添加节点',
        txt6:'返回上一页',
        txt7:'取消',
        txt8:'确定',
        txt9:'节点名称',
        txt10:'请输入节点名称',
        txt11:'内网地址',
        txt12:'请输入内网地址',
        txt13:'外网地址',
        txt14:'请输入外网地址',
        txt15:'端口',
        txt16:'请输入端口',
        txt17:'URL链接',
        txt18:'请输入URL链接',
        txt19:'描述',
        txt20:'请输入描述',
        txt21:'请输入节点名称',
        txt22:'必须以字母开头，且以字母、数字、下划线(_)随意组合',
        txt23:'请输入内网地址',
        txt24:'请输入有效合格的IP地址',
        txt25:'请输入外网地址',
        txt26:'请输入有效合格的IP地址或正确的域名地址',
        txt27:'请输入端口',
        txt28:'端口号仅为数字，取值范围是[0-65535]'
    },
    editQueue:{
        txt1:'当前位置：',
        txt2:'资源管理',
        txt3:'队列管理',
        txt4:'编辑队列',
        txt5:'返回上一页',
        txt6:'取消',
        txt7:'确定',
        txt8:'队列名称',
        txt9:'请输入队列名称',
        txt10:'分配主机',
        txt11:'请输入主机名称',
        txt12:'CPU核数',
        txt13:'请选择主机',
        txt14:'选择项目',
        txt15:'选择用户',
        txt16:'请输入用户名称',
        txt17:'请选择用户',
        txt18:'请输入节点名称',
        txt19:'必须以字母开头，且以字母、数字、下划线(_)随意组合',
        txt20:'请输入内网地址',
        txt21:'请输入有效合格的IP地址',
        txt22:'请输入外网地址',
        txt23:'请输入有效合格的IP地址或正确的域名地址',
        txt24:'请输入端口',
        txt25:'端口号仅为数字，取值范围是[0-65535]',
        txt26:'请选择'
    },
    editTask:{
        txt1:'当前位置：',
        txt2:'资源管理',
        txt3:'作业管理',
        txt4:'作业提交',
        txt5:'返回上一页',
        txt6:'取消',
        txt7:'运行',
        txt8:'作业名称',
        txt9:'请输入',
        txt10:'选择队列',
        txt11:'请选择',
        txt12:'编辑脚本',
        txt13:'上传脚本',
        txt14:'请输入作业名称',
        txt15:'必须以字母开头，且以字母、数字、下划线(_)随意组合',
        txt16:'请输入脚本内容',
        txt17:'运行成功!',
        txt18:'请删除后上传，当前限制选择文件数量为：',
        txt19:'上传成功!',
        txt20:'文件名',
        txt21:'保存成功!'
    },
    onlineUser:{
        txt1:'当前位置：',
        txt2:'资源管理',
        txt3:'在线用户',
        txt4:'序号',
        txt5:'用户名',
        txt6:'姓名',
        txt7:'桌面节点名称',
        txt8:'内网',
        txt9:'外网',
        txt10:'操作',
        txt11:'关闭桌面',
        txt12:'确定要关闭该桌面吗',
        txt13:'关闭',
        txt14:'确定',
        txt15:'取消',
        txt16:'已取消关闭'
    },
    queueManangement:{
        txt1:'当前位置：',
        txt2:'资源管理',
        txt3:'队列管理',
        txt4:'添加队列',
        txt5:'主机',
        txt6:'项目',
        txt7:'用户',
        txt8:'主机：',
        txt9:'添加队列',
        txt10:'确定删除该队列吗？',
        txt11:'删除该队列，该队列上的数据将会被清除！',
        txt12:'确定',
        txt13:'取消',
        txt14:'已取消删除',
        txt15:'删除成功!'
    },
    taskManangement:{
        txt1:'当前位置：',
        txt2:'资源管理',
        txt3:'作业管理',
        txt4:'请输入用户名',
        txt5:'查询',
        txt6:'请输入队列名称',
        txt7:'作业提交',
        txt8:'序号',
        txt9:'作业ID',
        txt10:'队列名称',
        txt11:'脚本名称',
        txt12:'用户名',
        txt13:'用时',
        txt14:'状态',
        txt15:'操作',
        txt16:'终止',
        txt17:'终止成功!',
        txt18:'确定终止该作业吗',
        txt19:'确定',
        txt20:'取消',
        txt21:'已取消终止'
    },
    userAssignment:{
        txt1:'当前位置：',
        txt2:'资源管理',
        txt3:'桌面节点',
        txt4:'用户分配',
        txt5:'取消',
        txt6:'确定',
        txt7:'节点名称：',
        txt8:'请输入您想要搜索的用户',
        txt9:'查询',
        txt10:'全部用户列表',
        txt11:'已选用户列表',
        txt12:'用户名'
    },
    tag:{
        txt1:'系统设置'
    },
    authManagement:{
        txt1:'当前位置：',
        txt2:'系统设置',
        txt3:'权限管理',
        txt4:'序号',
        txt5:'角色名称',
        txt6:'角色编码',
        txt7:'菜单权限分配',
        txt8:'保存',
        txt9:'全选',
        txt10:'保存成功！'
    },
    editMenu:{
        txt10:'当前位置：',
        txt11:'系统设置',
        txt12:'菜单管理',
        txt13:'编辑菜单',
        txt14:'添加菜单',
        txt15:'返回上一页',
        txt16:'取消',
        txt17:'确定',
        txt18:'菜单名称',
        txt19:'请输入菜单名称',
        txt20:'请输入菜单URL',
        txt21:'菜单URL',
        txt22:'父级菜单',
        txt23:'菜单类型',
        txt24:'请选择菜单类型',
        txt25:'菜单图标',
        txt26:'图标要求：',
        txt27:'图片长宽200px*200px，图片文件不超 过200KB，支持png、jpg、jpeg',
        txt28:'删除图片',
        txt29:'请输入菜单名称',
        txt30:'请输入菜单URL',
        txt31:'请选择菜单类型',
        txt32:'请求转发(本系统)',
        txt33:'重定向(比如重定向到第三方网站)',
        txt34:'内部跳转(特定请求) 打开新的页面',
        txt35:'顶级菜单',
        txt36:'保存成功！',
        txt37:'当前限制选择 1 个文件，本次选择了1个文件，共选择了1个文件，请删除后上传'
    },
    logManagement:{
        txt1:'当前位置：',
        txt2:'系统设置',
        txt3:'日志管理',
        txt4:'序号',
        txt5:'日志类型',
        txt6:'所属模块',
        txt7:'内容',
        txt8:'用户ID',
        txt9:'用户名',
        txt10:'记录时间'
    },
    menuManagement:{
        txt1:'当前位置：',
        txt2:'系统设置',
        txt3:'菜单管理',
        txt4:'添加菜单',
        txt5:'菜单名称',
        txt6:'菜单URL',
        txt7:'菜单类型',
        txt8:'菜单图标',
        txt9:'操作',
        txt10:'编辑',
        txt11:'删除',
        txt12:'请求转发(本系统)',
        txt13:'重定向(比如重定向到第三方网站)',
        txt14:'内部跳转(特定请求) 打开新的页面',
        txt15:'顶级菜单',
        txt16:'确定删除该菜单吗？',
        txt17:'删除该菜单，该菜单在系统中将会被清除！',
        txt18:'确定',
        txt19:'取消',
        txt20:'删除成功！'
    },
    roleManagement:{
        txt1:'当前位置：',
        txt2:'系统设置',
        txt3:'角色管理',
        txt4:'添加角色',
        txt5:'删除',
        txt6:'编辑',
        txt7:'序号',
        txt8:'角色名称',
        txt9:'角色描述',
        txt10:'操作',
        txt11:'用户名',
        txt12:'真实姓名',
        txt13:'手机号',
        txt14:'邮箱',
        txt15:'添加角色',
        txt16:'角色名称',
        txt17:'角色描述',
        txt18:'请输入角色描述',
        txt19:'请输入角色名称',
        txt20:'确定要删除该角色吗？',
        txt21:'已取消删除',
        txt22:'删除成功!',
        txt23:'添加成功!',
        txt24:'先请选择用户',
        txt25:'确定删除该用户吗？',
        txt26:'删除该用户，该用户在角色里信息将会被清除！',
        txt27:'取消',
        txt28:'确定',
        txt29:'删除成功!',
    },
    systemeManagement:{
        txt1:'当前位置：',
        txt2:'系统设置',
        txt3:'保存',
        txt4:'平台全局数据下载权限设置',
        txt5:'是否允许下载：',
        txt6:'允许下载情况下的不允许名单',
        txt7:'不允许下载情况下的允许名单',
        txt8:'请输入您要搜索的用户',
        txt9:'用户名',
        txt10:'保存成功！'
    },
    editEmail:{
        txt1:'当前位置：',
        txt2:'用户中心',
        txt3:'绑定手机',
        txt4:'绑定邮箱',
        txt5:'绑定新邮箱',
        txt6:'取消',
        txt7:'验证',
        txt8:'确定',
        txt9:'请输入绑定邮箱',
        txt10:'验证码',
        txt11:'请输入验证码',
        txt12:'已发送',
        txt13:'秒',
        txt14:'发送验证码',
        txt15:'重新获取',
        txt16:'新邮箱',
        txt17:'请输入新邮箱',
        txt18:'邮箱不能为空',
        txt19:'请输入正确的邮箱',
        txt20:'请输入邮箱验证码'
    },
    editPassword:{
        txt1:'当前位置：',
        txt2:'用户中心',
        txt3:'修改密码',
        txt4:'取消',
        txt5:'确定',
        txt6:'原密码',
        txt7:'请输入原密码',
        txt8:'新密码',
        txt9:'请输入新密码',
        txt10:'确认密码',
        txt11:'请确认新密码',
        txt12:'请输入密码',
        txt13:'确认密码不能为空',
        txt14:'两次输入密码不一致',
        txt15:'长度在 6 到 18 位'
    },
    editPhone:{
        txt1:'当前位置：',
        txt2:'用户中心',
        txt3:'绑定手机',
        txt4:'绑定新手机',
        txt5:'取消',
        txt6:'验证',
        txt7:'确定',
        txt8:'绑定手机',
        txt9:'请输入绑定手机',
        txt10:'验证码',
        txt11:'请输入验证码',
        txt12:'已发送1秒',
        txt13:'发送验证码',
        txt14:'重新获取',
        txt15:'新手机号码',
        txt16:'请输入新手机号码',
        txt17:'请输入手机号码',
        txt18:'请输入手机验证码',
        txt19:'请输入正确的手机号码'
    },
    userCenter:{
        txt1:'当前位置：',
        txt2:'用户中心',
        txt3:'取消',
        txt4:'用户名',
        txt5:'姓名',
        txt6:'请输入姓名',
        txt7:'保存',
        txt8:'密码',
        txt9:'修改密码',
        txt10:'绑定手机，让登录使用更方便',
        txt11:'更换手机',
        txt12:'绑定手机',
        txt13:'绑定邮箱，让登录使用更安全',
        txt14:'解除绑定',
        txt15:'绑定邮箱',
        txt16:'保存成功！',
    },
    activation:{
        txt1:'当前位置：',
        txt2:'用户管理',
        txt3:'激活用户',
        txt4:'取消',
        txt5:'确定',
        txt6:'有效期',
        txt7:'至',
        txt8:'开始日期',
        txt9:'结束日期',
        txt10:'请选择有效期',
        txt11:'解冻用户成功!'
    },
    addUser:{
        txt1:'编辑用户',
        txt2:'添加用户',
        txt3:'取消',
        txt4:'确定',
        txt5:'用户名',
        txt6:'请输入',
        txt7:'用户密码',
        txt8:'单位名称',
        txt9:'真实姓名',
        txt10:'单位地址',
        txt11:'有效期至',
        txt12:'开始日期',
        txt13:'结束日期',
        txt14:'请输入正确的邮箱',
        txt15:'请输入用户名',
        txt16:'请输入用户密码'
    },
    editPassword:{
        txt1:'当前位置：',
        txt2:'用户中心',
        txt3:'更改密码',
        txt4:'取消',
        txt5:"确认",
        txt6:'原始密码',
        txt7:'请输入原始密码',
        txt8:'新密码',
        txt9:'请输入新密码',
        txt10:'确认密码',
        txt11:'请确认新密码',
        txt12:'请输入密码',
        txt13:"确认密码不能为空",
        txt14:"输入的两个密码不匹配",
        txt15:'长度在6到18位之间'
    },
    editRole:{
        txt1:'当前位置：',
        txt2:'用户管理',
        txt3:'修改角色',
        txt4:'取消',
        txt5:'确定',
        txt6:'系统角色',
        txt7:'请选择系统角色',
    },
    userManagement:{
        txt1:'当前位置：',
        txt2:'用户管理',
        txt3:'请输入手机号/用户名/真实姓名',
        txt4:'查询',
        txt5:'导入用户',
        txt6:'导出模板',
        txt7:'添加用户',
        txt8:'序号',
        txt9:'用户名',
        txt10:'真实姓名',
        txt11:'手机号',
        txt12:'邮箱',
        txt13:'角色',
        txt14:'有效期至',
        txt15:'操作',
        txt16:'修改密码',
        txt17:'修改角色',
        txt18:'删除',
        txt19:'激活',
        txt20:'冻结',
        txt21:'有效期',
        txt22:'开始日期',
        txt23:'结束日期',
        txt24:'确 定',
        txt25:'取 消',
        txt26:'请选择有效期',
        txt27:'用户列表',
        txt28:'当前限制选择 1 个文件，本次选择了1个文件，共选择了 1个文件，请删除后上传',
        txt29:'上传成功!',
        txt30:'确定要删除该用户吗',
        txt31:'同时会删除该用户下的所有数据。',
        txt32:'已取消删除',
        txt33:'确定要冻结该用户吗',
        txt34:'冻结后将无法登陆平台。',
        txt35:'冻结',
        txt36:'冻结用户成功!',
        txt37:'解冻用户成功!',
        txt38:'已取消冻结'
    },
    noPermission:{
        txt1:'暂无权限'
    },
    workPlat:{
        txt1:'我的数据',
        txt2:'我的文件',
        txt3:'我的分享',
        txt4:'接收分享',
        txt5:'共享空间',
        txt6:'管理的项目',
        txt7:'参与的项目',
        txt8:'审批管理',
        txt9:'用户管理',
        txt10:'资源管理',
        txt11:'桌面节点',
        txt12:'计算节点',
        txt13:'队列管理',
        txt14:'作业管理',
        txt15:'平台监控',
        txt16:'集群监控',
        txt17:'应用管理'
    }
}